import { ref as r, onMounted as c, onUnmounted as i, defineComponent as m, getCurrentInstance as y, openBlock as S, createElementBlock as h } from "vue";
import W from "wavesurfer.js";
const g = ({ containerRef: e, options: l }) => {
  const a = r(null), t = () => {
    e.value && (a.value = W.create({
      container: e.value,
      ...l
    }));
  }, n = () => {
    a.value && (a.value.destroy(), a.value = null);
  };
  return c(() => {
    t();
  }), i(() => {
    n();
  }), { waveSurfer: a };
}, _ = (e) => {
  const l = r(!1), a = r(!1), t = r(0), n = r(0), o = () => {
    l.value = !1, a.value = !1, t.value = 0;
  }, u = (p) => {
    l.value = !0, a.value = !1, t.value = 0, n.value = p;
  }, s = () => {
    a.value = !0;
  }, v = () => {
    a.value = !1;
  }, d = () => {
    e.value && (t.value = e.value.getCurrentTime());
  }, f = () => {
    l.value = !1, a.value = !1;
  };
  return c(() => {
    e.value && (e.value.on("load", o), e.value.on("ready", u), e.value.on("play", s), e.value.on("pause", v), e.value.on("timeupdate", d), e.value.on("destroy", f));
  }), i(() => {
    e.value && e.value.unAll();
  }), {
    isReady: l,
    isPlaying: a,
    currentTime: t,
    totalDuration: n
  };
}, k = ({ containerRef: e, options: l }) => {
  const { waveSurfer: a } = g({ containerRef: e, options: l }), { isReady: t, totalDuration: n, isPlaying: o, currentTime: u } = _(a);
  return {
    waveSurfer: a,
    isReady: t,
    totalDuration: n,
    isPlaying: o,
    currentTime: u
  };
}, P = ["audioprocess", "click", "dblclick", "decode", "drag", "finish", "init", "interaction", "load", "loading", "pause", "play", "ready", "redraw", "redrawcomplete", "scroll", "seeking", "timeupdate", "zoom"], T = /* @__PURE__ */ m({
  __name: "WaveSurferPlayer",
  props: {
    options: {}
  },
  setup(e) {
    const l = e, a = r(null), { waveSurfer: t } = k({ containerRef: a, options: l.options }), n = y();
    return c(() => {
      P.forEach((o) => {
        var u;
        (u = t.value) == null || u.on(o, (...s) => {
          n == null || n.emit(o, ...s);
        });
      }), n == null || n.emit("waveSurfer", t.value);
    }), (o, u) => (S(), h("div", {
      ref_key: "containerRef",
      ref: a
    }, null, 512));
  }
});
export {
  T as WaveSurferPlayer,
  k as useWaveSurfer
};
